import React from 'react'
import BreadcrumbThree from '../components/BreadcrumbThree'
import OrderDetails from '../components/OrderDetails'
import { Helmet } from 'react-helmet-async'


const OrderDetailsPage = () => {
  return (
    <>
        <Helmet>
          <title> Order | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
        </Helmet>

        {/* Breadcrumb */}
        <BreadcrumbThree title={"Order Details"} />

        {/* ShopSection */}
        <OrderDetails />
    </>
  )
}

export default OrderDetailsPage